import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import "./MoveDocumentModal.css";

const MoveDocumentModal = ({ show, onHide, document, onSave, containers, setShowToast, setToastInfo }) => {
  const [newContainer, setNewContainer] = useState("");
  const [disabledButtonState, setDisabledButtonState] = useState(true)

  // Derived value (not state) — recomputed every render from the inputs that
  // determine it. The Move button is disabled when the user hasn't picked a
  // new container, or when they've picked the document's current container
  // (which would be a no-op move). Storing this in useState would require a
  // useEffect to keep it in sync — that's an anti-pattern when the value is
  // a pure function of existing state/props.
  // const disabledButtonState =
  //   !newContainer || newContainer === document.containerName;

  const handleMove = async () => {
    try {
      const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
      const API_KEY = process.env.REACT_APP_SERVER_API_KEY;
      await axios.put(
        `${API_BASE_URL}/blob/container/${document.containerName}/move/${document.name}`,
        {
          newContainer,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-api-key": API_KEY,
          },
        }
      );
      setToastInfo({
        header: "File Moved Successfully",
        body: `Successfully moved document: ${document.name}`,
        variant: "warning"
      });
      setShowToast(true);
      onSave(); // Refresh the parent component after moving
      onHide(); // Close the modal
    } catch (error) {
      console.error("Error moving document:", error);
      setToastInfo({
        header: "Error",
        body: `Error moving file: ${error}`,
        variant: "danger",
      });
      setShowToast(true);
    }
  };

  const disableButton = () => {
    if ((!!newContainer === false) || newContainer === document.containerName) {
      return setDisabledButtonState(true);
    }
    return setDisabledButtonState(false);
  };

  useEffect(() => {
    disableButton()
  }, [newContainer]) // eslint-disable-line react-hooks/exhaustive-deps
  

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Move Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>New Container</Form.Label>
            <Form.Control
              style={{ borderTopLeftRadius: "0" }}
              as="select"
              value={newContainer}
              onChange={(e) => setNewContainer(e.target.value)}
            >
              <option value="">Select Container</option>
              {containers.map((container) => (
                <option key={container} value={container}>
                  {container}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleMove} disabled={disabledButtonState}>
          Move Document
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveDocumentModal;
